import * as types from '../constants/actionTypes';

export function showBroadcast(message) {
    return {
        type: types.SHOW_BROADCAST,
        message,
    };
}

export function removeBroadcast() {
    return {
        type: types.REMOVE_BROADCAST,
    };
}
